import axios from "axios";

const url = "https://studio-cypher-combined.uc.r.appspot.com"

export default {
    ///septris-register-user (use this to register and also complete the step after the player logs in)
    // Params: user_id, first_name, last_name
    // Note: user_id should NOT be their google email. We should hash it somehow.
    // returns: current_session_id, current_session (might be null, if the player has no current session or is new)
    registerUser(user_id, first_name, last_name){
        return axios.post(url + "/septris-register-user", {
            user_id: user_id,
            first_name: first_name,
            last_name: last_name
        });
    },

    // /septris-load-user
    // Params: user_id
    // Returns: first_name, last_name or ERROR
    loadUser(user_id){
        return axios.post(url + "/septris-load-user", {user_id: user_id});
    },

    // /septris-start-new-session - use this to begin a new game
    // If the player is NOT logged in, do not pass user_id. We use this because we're going to save every player action, the way we did for safety quest
    // Params: user_id
    // returns: session_id
    startNewSession(user_id){
        if(user_id){
            return axios.post(url + "/septris-start-new-session", {user_id: user_id});
        }
        return new Promise(resolve=>{resolve()});
    },

    // /septris-finish-session - use this to delete the user's current session (removes the id from the user object, session stays on server)
    // Params: user_id
    // returns 200
    finishSession(user_id){
        return axios.post(url + "/septris-finish-session", {user_id: user_id});
    },

    // /septris-save-session
    // Params: user_id, session_id, session (stringified session data)
    // returns 200
    saveSession(user_id, session_id, session){
        return axios.post(url + "/septris-save-session", {
            user_id: user_id,
            session_id: session_id,
            session: session
        })
    },

    // /septris-load-session
    // Params: session_id
    // returns: session, user_id, first_name, last_name
    loadSession(session_id){
        return axios.post(url + "/septris-load-session", {session_id: session_id})
    },

    // septris-save-score
    // parameters:
    // name
    // loc - (the location of the septris, should be in an env for delployment?)
    // department
    // score
    // speed (a string, like low, med, high, whatever)
    saveScore(name, loc, department, score, speed){
        return axios.post(url + "/septris-save-score", {
            name: name,
            loc: loc,
            department: department,
            score: score,
            speed: speed
        });
    },

    // loc (if not set it grabs all scores)
    // speed (if set to all it ignores speed)
    loadScore(location, speed){
        return axios.post(url + "/septris-load-score", {loc: location, speed: speed});
    }
}
